/**
 * @fileoverview gRPC-Web generated client stub for accountsettings
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: accountsettings/accountsettings.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var promptoverridesources_promptoverridesources_pb = require('../promptoverridesources/promptoverridesources_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.accountsettings = require('./accountsettings_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountsettings.AccountSettingsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountsettings.AccountSettingsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetDateLimitResponse>}
 */
const methodDescriptor_AccountSettings_GetDateLimit = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetDateLimit',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetDateLimitResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetDateLimitResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetDateLimitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetDateLimitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getDateLimit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetDateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetDateLimit,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetDateLimitResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getDateLimit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetDateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetDateLimit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.UpdateDateLimitRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_UpdateDateLimit = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/UpdateDateLimit',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.UpdateDateLimitRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.UpdateDateLimitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.UpdateDateLimitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.updateDateLimit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateDateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateDateLimit,
      callback);
};


/**
 * @param {!proto.accountsettings.UpdateDateLimitRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.updateDateLimit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateDateLimit',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateDateLimit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.ValidateImageTimestamps>}
 */
const methodDescriptor_AccountSettings_GetValidateImageTimestamps = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetValidateImageTimestamps',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.ValidateImageTimestamps,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.ValidateImageTimestamps.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.ValidateImageTimestamps)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.ValidateImageTimestamps>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getValidateImageTimestamps =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetValidateImageTimestamps',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetValidateImageTimestamps,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.ValidateImageTimestamps>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getValidateImageTimestamps =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetValidateImageTimestamps',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetValidateImageTimestamps);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.UpdateValidateImageTimestampsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_UpdateValidateImageTimestamps = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/UpdateValidateImageTimestamps',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.UpdateValidateImageTimestampsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.UpdateValidateImageTimestampsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.UpdateValidateImageTimestampsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.updateValidateImageTimestamps =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateValidateImageTimestamps',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateValidateImageTimestamps,
      callback);
};


/**
 * @param {!proto.accountsettings.UpdateValidateImageTimestampsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.updateValidateImageTimestamps =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateValidateImageTimestamps',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateValidateImageTimestamps);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetAccountPromptOverrideSourceResponse>}
 */
const methodDescriptor_AccountSettings_GetAccountPromptOverrideSource = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetAccountPromptOverrideSource',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetAccountPromptOverrideSourceResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetAccountPromptOverrideSourceResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetAccountPromptOverrideSourceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetAccountPromptOverrideSourceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getAccountPromptOverrideSource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetAccountPromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetAccountPromptOverrideSource,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetAccountPromptOverrideSourceResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getAccountPromptOverrideSource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetAccountPromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetAccountPromptOverrideSource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.UpdateAccountPromptOverrideSourceRequest,
 *   !proto.accountsettings.UpdateAccountPromptOverrideSourceResponse>}
 */
const methodDescriptor_AccountSettings_UpdateAccountPromptOverrideSource = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/UpdateAccountPromptOverrideSource',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.UpdateAccountPromptOverrideSourceRequest,
  proto.accountsettings.UpdateAccountPromptOverrideSourceResponse,
  /**
   * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.UpdateAccountPromptOverrideSourceResponse.deserializeBinary
);


/**
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.UpdateAccountPromptOverrideSourceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.updateAccountPromptOverrideSource =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateAccountPromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateAccountPromptOverrideSource,
      callback);
};


/**
 * @param {!proto.accountsettings.UpdateAccountPromptOverrideSourceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.UpdateAccountPromptOverrideSourceResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.updateAccountPromptOverrideSource =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateAccountPromptOverrideSource',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateAccountPromptOverrideSource);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetUsesNewAuditScanByDefaultResponse>}
 */
const methodDescriptor_AccountSettings_GetUsesNewAuditScanByDefault = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetUsesNewAuditScanByDefault',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetUsesNewAuditScanByDefaultResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetUsesNewAuditScanByDefaultResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetUsesNewAuditScanByDefaultResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getUsesNewAuditScanByDefault =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetUsesNewAuditScanByDefault',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetUsesNewAuditScanByDefault,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetUsesNewAuditScanByDefaultResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getUsesNewAuditScanByDefault =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetUsesNewAuditScanByDefault',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetUsesNewAuditScanByDefault);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_UpdateUsesNewAuditScanByDefault = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/UpdateUsesNewAuditScanByDefault',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.updateUsesNewAuditScanByDefault =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateUsesNewAuditScanByDefault',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateUsesNewAuditScanByDefault,
      callback);
};


/**
 * @param {!proto.accountsettings.UpdateUsesNewAuditScanByDefaultRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.updateUsesNewAuditScanByDefault =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateUsesNewAuditScanByDefault',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateUsesNewAuditScanByDefault);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetShowOldComplianceDashboardResponse>}
 */
const methodDescriptor_AccountSettings_GetShowOldComplianceDashboard = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetShowOldComplianceDashboard',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetShowOldComplianceDashboardResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetShowOldComplianceDashboardResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetShowOldComplianceDashboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetShowOldComplianceDashboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getShowOldComplianceDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetShowOldComplianceDashboard',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetShowOldComplianceDashboard,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetShowOldComplianceDashboardResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getShowOldComplianceDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetShowOldComplianceDashboard',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetShowOldComplianceDashboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.UpdateNotificationsPausedRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_UpdateNotificationsPaused = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/UpdateNotificationsPaused',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.UpdateNotificationsPausedRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.UpdateNotificationsPausedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.UpdateNotificationsPausedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.updateNotificationsPaused =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateNotificationsPaused',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateNotificationsPaused,
      callback);
};


/**
 * @param {!proto.accountsettings.UpdateNotificationsPausedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.updateNotificationsPaused =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/UpdateNotificationsPaused',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_UpdateNotificationsPaused);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetChildReportingConfigResponse>}
 */
const methodDescriptor_AccountSettings_GetChildReportingConfig = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetChildReportingConfig',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetChildReportingConfigResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetChildReportingConfigResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetChildReportingConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetChildReportingConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getChildReportingConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetChildReportingConfig',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetChildReportingConfig,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetChildReportingConfigResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getChildReportingConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetChildReportingConfig',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetChildReportingConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.SaveChildReportingConfigRequest,
 *   !proto.accountsettings.SaveChildReportingConfigResponse>}
 */
const methodDescriptor_AccountSettings_SaveChildReportingConfig = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/SaveChildReportingConfig',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.SaveChildReportingConfigRequest,
  proto.accountsettings.SaveChildReportingConfigResponse,
  /**
   * @param {!proto.accountsettings.SaveChildReportingConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.SaveChildReportingConfigResponse.deserializeBinary
);


/**
 * @param {!proto.accountsettings.SaveChildReportingConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.SaveChildReportingConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.SaveChildReportingConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.saveChildReportingConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/SaveChildReportingConfig',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_SaveChildReportingConfig,
      callback);
};


/**
 * @param {!proto.accountsettings.SaveChildReportingConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.SaveChildReportingConfigResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.saveChildReportingConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/SaveChildReportingConfig',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_SaveChildReportingConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetIndexPageFilterSettingsResponse>}
 */
const methodDescriptor_AccountSettings_GetIndexPageFilterSettings = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetIndexPageFilterSettings',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetIndexPageFilterSettingsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetIndexPageFilterSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetIndexPageFilterSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetIndexPageFilterSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getIndexPageFilterSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetIndexPageFilterSettings',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetIndexPageFilterSettings,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetIndexPageFilterSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getIndexPageFilterSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetIndexPageFilterSettings',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetIndexPageFilterSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.SetIndexPageFilterVisibilityRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_SetIndexPageFilterVisibility = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/SetIndexPageFilterVisibility',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.SetIndexPageFilterVisibilityRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.SetIndexPageFilterVisibilityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.SetIndexPageFilterVisibilityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.setIndexPageFilterVisibility =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/SetIndexPageFilterVisibility',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_SetIndexPageFilterVisibility,
      callback);
};


/**
 * @param {!proto.accountsettings.SetIndexPageFilterVisibilityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.setIndexPageFilterVisibility =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/SetIndexPageFilterVisibility',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_SetIndexPageFilterVisibility);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.ResetIndexPageFiltersRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_ResetIndexPageFilters = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/ResetIndexPageFilters',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.ResetIndexPageFiltersRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.ResetIndexPageFiltersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.ResetIndexPageFiltersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.resetIndexPageFilters =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/ResetIndexPageFilters',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_ResetIndexPageFilters,
      callback);
};


/**
 * @param {!proto.accountsettings.ResetIndexPageFiltersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.resetIndexPageFilters =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/ResetIndexPageFilters',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_ResetIndexPageFilters);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetIndexPageColumnSettingsResponse>}
 */
const methodDescriptor_AccountSettings_GetIndexPageColumnSettings = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetIndexPageColumnSettings',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetIndexPageColumnSettingsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetIndexPageColumnSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetIndexPageColumnSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetIndexPageColumnSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getIndexPageColumnSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetIndexPageColumnSettings',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetIndexPageColumnSettings,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetIndexPageColumnSettingsResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getIndexPageColumnSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetIndexPageColumnSettings',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetIndexPageColumnSettings);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.SetIndexPageColumnVisibilityRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_SetIndexPageColumnVisibility = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/SetIndexPageColumnVisibility',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.SetIndexPageColumnVisibilityRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.SetIndexPageColumnVisibilityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.SetIndexPageColumnVisibilityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.setIndexPageColumnVisibility =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/SetIndexPageColumnVisibility',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_SetIndexPageColumnVisibility,
      callback);
};


/**
 * @param {!proto.accountsettings.SetIndexPageColumnVisibilityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.setIndexPageColumnVisibility =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/SetIndexPageColumnVisibility',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_SetIndexPageColumnVisibility);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountsettings.ResetIndexPageColumnsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_AccountSettings_ResetIndexPageColumns = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/ResetIndexPageColumns',
  grpc.web.MethodType.UNARY,
  proto.accountsettings.ResetIndexPageColumnsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.accountsettings.ResetIndexPageColumnsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.accountsettings.ResetIndexPageColumnsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.resetIndexPageColumns =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/ResetIndexPageColumns',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_ResetIndexPageColumns,
      callback);
};


/**
 * @param {!proto.accountsettings.ResetIndexPageColumnsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.resetIndexPageColumns =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/ResetIndexPageColumns',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_ResetIndexPageColumns);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.accountsettings.GetHiddenReceptorsResponse>}
 */
const methodDescriptor_AccountSettings_GetHiddenReceptors = new grpc.web.MethodDescriptor(
  '/accountsettings.AccountSettings/GetHiddenReceptors',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.accountsettings.GetHiddenReceptorsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountsettings.GetHiddenReceptorsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountsettings.GetHiddenReceptorsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountsettings.GetHiddenReceptorsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountsettings.AccountSettingsClient.prototype.getHiddenReceptors =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetHiddenReceptors',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetHiddenReceptors,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountsettings.GetHiddenReceptorsResponse>}
 *     Promise that resolves to the response
 */
proto.accountsettings.AccountSettingsPromiseClient.prototype.getHiddenReceptors =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountsettings.AccountSettings/GetHiddenReceptors',
      request,
      metadata || {},
      methodDescriptor_AccountSettings_GetHiddenReceptors);
};


module.exports = proto.accountsettings;

